/* ADD GROUPS */
export const LIST_POLLS = "LIST_POLLS"
export const LIST_POLLS_SUCCESS = "LIST_POLLS_SUCCESS"
export const LIST_POLLS_CLEAN = "LIST_POLLS_CLEAN"
export const LIST_POLLS_ERROR = "LIST_POLLS_ERROR"
